export var CTADeviceNames;

(function (CTADeviceNames) {
  CTADeviceNames["desktop"] = "desktop";
  CTADeviceNames["mobile"] = "mobile";
  CTADeviceNames["nativeIOS"] = "nativeIOS";
  CTADeviceNames["nativeAndroid"] = "nativeAndroid";
})(CTADeviceNames || (CTADeviceNames = {}));

export var NAVIGATION_TARGETS;

(function (NAVIGATION_TARGETS) {
  NAVIGATION_TARGETS["BLANK"] = "_blank";
  NAVIGATION_TARGETS["SELF"] = "_self";
})(NAVIGATION_TARGETS || (NAVIGATION_TARGETS = {}));

export var CtaSectionType;

(function (CtaSectionType) {
  CtaSectionType["CTA"] = "CTA";
  CtaSectionType["OPTIN"] = "Opt-in";
  CtaSectionType["EVENT"] = "CTA-Event";
  CtaSectionType["SELECTIONS"] = "Markets/Offers";
})(CtaSectionType || (CtaSectionType = {}));

export var ImageResolution;

(function (ImageResolution) {
  ImageResolution["HIGH"] = "high";
  ImageResolution["MEDIUM"] = "medium";
  ImageResolution["LOW"] = "low";
})(ImageResolution || (ImageResolution = {}));

export var AdobeDeviceNames;

(function (AdobeDeviceNames) {
  AdobeDeviceNames["desktop"] = "desktop";
  AdobeDeviceNames["mobile"] = "mobile";
  AdobeDeviceNames["tablet"] = "tablet";
})(AdobeDeviceNames || (AdobeDeviceNames = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9lbnVtcy50cyJdLCJuYW1lcyI6WyJDVEFEZXZpY2VOYW1lcyIsIk5BVklHQVRJT05fVEFSR0VUUyIsIkN0YVNlY3Rpb25UeXBlIiwiSW1hZ2VSZXNvbHV0aW9uIiwiQWRvYmVEZXZpY2VOYW1lcyJdLCJtYXBwaW5ncyI6IkFBQUEsV0FBWUEsY0FBWjs7V0FBWUEsYztBQUFBQSxFQUFBQSxjO0FBQUFBLEVBQUFBLGM7QUFBQUEsRUFBQUEsYztBQUFBQSxFQUFBQSxjO0dBQUFBLGMsS0FBQUEsYzs7QUFPWixXQUFZQyxrQkFBWjs7V0FBWUEsa0I7QUFBQUEsRUFBQUEsa0I7QUFBQUEsRUFBQUEsa0I7R0FBQUEsa0IsS0FBQUEsa0I7O0FBS1osV0FBWUMsY0FBWjs7V0FBWUEsYztBQUFBQSxFQUFBQSxjO0FBQUFBLEVBQUFBLGM7QUFBQUEsRUFBQUEsYztBQUFBQSxFQUFBQSxjO0dBQUFBLGMsS0FBQUEsYzs7QUFPWixXQUFZQyxlQUFaOztXQUFZQSxlO0FBQUFBLEVBQUFBLGU7QUFBQUEsRUFBQUEsZTtBQUFBQSxFQUFBQSxlO0dBQUFBLGUsS0FBQUEsZTs7QUFZWixXQUFZQyxnQkFBWjs7V0FBWUEsZ0I7QUFBQUEsRUFBQUEsZ0I7QUFBQUEsRUFBQUEsZ0I7QUFBQUEsRUFBQUEsZ0I7R0FBQUEsZ0IsS0FBQUEsZ0IiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBDVEFEZXZpY2VOYW1lcyB7XG4gIGRlc2t0b3AgPSAnZGVza3RvcCcsXG4gIG1vYmlsZSA9ICdtb2JpbGUnLFxuICBuYXRpdmVJT1MgPSAnbmF0aXZlSU9TJyxcbiAgbmF0aXZlQW5kcm9pZCA9ICduYXRpdmVBbmRyb2lkJyxcbn1cblxuZXhwb3J0IGVudW0gTkFWSUdBVElPTl9UQVJHRVRTIHtcbiAgQkxBTksgPSAnX2JsYW5rJyxcbiAgU0VMRiA9ICdfc2VsZicsXG59XG5cbmV4cG9ydCBlbnVtIEN0YVNlY3Rpb25UeXBlIHtcbiAgQ1RBID0gJ0NUQScsXG4gIE9QVElOID0gJ09wdC1pbicsXG4gIEVWRU5UID0gJ0NUQS1FdmVudCcsXG4gIFNFTEVDVElPTlMgPSAnTWFya2V0cy9PZmZlcnMnLFxufVxuXG5leHBvcnQgZW51bSBJbWFnZVJlc29sdXRpb24ge1xuICBISUdIID0gJ2hpZ2gnLFxuICBNRURJVU0gPSAnbWVkaXVtJyxcbiAgTE9XID0gJ2xvdycsXG59XG5cbi8qKlxuICogQGRlcHJlY2F0ZWRcbiAqXG4gKiBQbGVhc2UgdXNlIENUQURldmljZU5hbWVzIGluc3RlYWRcbiAqIFRoaXMgd2lsbCBiZSByZW1vdmVkIGluIHRoZSBmdXR1cmVcbiAqL1xuZXhwb3J0IGVudW0gQWRvYmVEZXZpY2VOYW1lcyB7XG4gIGRlc2t0b3AgPSAnZGVza3RvcCcsXG4gIG1vYmlsZSA9ICdtb2JpbGUnLFxuICB0YWJsZXQgPSAndGFibGV0Jyxcbn1cbiJdfQ==